exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".st0--1qB5qF0G{fill:#3faed5;stroke:#fff;stroke-width:3;stroke-miterlimit:10}.st1--1taMp472{fill:#fff}.st2--31hyHJpg{fill:#6f7985}.st2--31hyHJpg,.st3--1pgr4s62{stroke:#fff;stroke-width:3;stroke-miterlimit:10}.st3--1pgr4s62,.st4--20WXEF21{fill:#58616b}.st5--1v3vqwv5{fill:#fcfdfa}.st6--2UG_0Sez{fill:#fcfcfc}.st7--LbBc4x0m{fill:none;stroke:#e4e6ea;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st8--2RpcSEL8{font-family:Lato;font-weight:700}.st9--N3Zln2Fi{font-size:23.9663px}.ipadStandard--2m4wKqN4{enable-background:new 0 0 356.5 500}", ""]);

// exports
exports.locals = {
	"st0": "st0--1qB5qF0G",
	"st1": "st1--1taMp472",
	"st2": "st2--31hyHJpg",
	"st3": "st3--1pgr4s62",
	"st4": "st4--20WXEF21",
	"st5": "st5--1v3vqwv5",
	"st6": "st6--2UG_0Sez",
	"st7": "st7--LbBc4x0m",
	"st8": "st8--2RpcSEL8",
	"st9": "st9--N3Zln2Fi",
	"ipadStandard": "ipadStandard--2m4wKqN4"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/shared/ipad-standard/styles.scss
// module id = 1027
// module chunks = 0